const routes = {
    home: '/',
    following: '/following',
    profile: '/:nickname',
    upload: '/upload',
    live: '/live',
    friends: '/friends',
    explore: '/explore',
    detailVideo: '/:nickname/video/:uuid',
    setting: '/setting',
    finding: '/search/users'
}

export default routes;